import AxiosInterceptor from "../../AxiosInterceptorHearro";


// 환자 연습 시간 조회
// request data
//  - pid
export function getPatientTrainAmountFromHearro(request) {
    return AxiosInterceptor({
        url: '/patient/amount',
        method: 'get',
        params: request,
    })
}


// 환자 최근 주차 조회
// request data
//  - pid
export function getPatientLastWeekFromHearro(request) {
    return AxiosInterceptor({
        url: '/patient/last-week',
        method: 'get',
        params: request
    })
}


// 환자 주차별 결과 조회
// request data
//  - pid
//  - week
export function getPatientTrainWeeklyResultFromHearro(request) {
    return AxiosInterceptor({
        url: '/patient/result-week',
        method: 'get',
        params: request,
    })
}


// 환자 연습 결과 조회
// request data
//  - pid
export function getPatientTrainTotalResultFromHearro(request) {
    return AxiosInterceptor({
        url: '/patient/result-all',
        method: 'get',
        params: request,
    })
}


// 게임 리스트 조회
// request data
//  - codeGrp
export function getGameListFromHearro() {
    return AxiosInterceptor({
        url: '/base/code/11',
        method: 'get'
    })
}


// 게임 이력 리스트 조회
// request data
//  - pid *required
//  - trainId: 게임 코드
//  - month: 입력한 숫자만큼 이전 달을 출력 (현재 달은 0, 1은 1달 전)
//  - week: 학습 시작 기준의 주차 (현재 달은 최근 주차 조회로 확인 가능)
//  - page
export function getTrainHistoryFromHearro(request) {
    return AxiosInterceptor({
        url: '/patient/train-history',
        method: 'get',
        params: request
    })
}


// 게임별 사용 시간 및 횟수 & 평균 점수 조회
// request data
//  - pid *required
//  - trainId: 게임 코드
//  - month: 입력한 숫자만큼 이전 달을 출력 (현재 달은 0, 1은 1달 전)
//  - week: 학습 시작 기준의 주차 (현재 달은 최근 주차 조회로 확인 가능)
export function getTrainCountAmountScoreFromHearro(request){
    return AxiosInterceptor({
        url: '/patient/train-count-amount',
        method: 'get',
        params: request
    })
}
